import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { mediaUrl } from "../lib/api";
import { ease, fmtDate } from "../lib/content";

export const ArticleCard = ({ article, index = 0, featured = false }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay: (index % 3) * 0.08 }}
    className={featured ? "md:col-span-2 lg:col-span-3" : ""}
  >
    <Link to={`/insights/${article?.slug}`} data-testid={`article-card-${index}`} className={`group grid gap-6 ${featured ? "lg:grid-cols-12 lg:items-center lg:gap-12" : ""}`}>
      <div className={`relative overflow-hidden bg-mist ${featured ? "aspect-[16/10] lg:col-span-7" : "aspect-[4/3]"}`}>
        {article?.cover_image && (
          <img src={mediaUrl(article.cover_image)} alt={article?.title} className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.06]" />
        )}
        <span className="absolute left-4 top-4 rounded-full bg-paper/95 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] text-teal">{article?.category}</span>
      </div>
      <div className={featured ? "lg:col-span-5" : ""}>
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-teal/75">
          {fmtDate(article?.published_at)} · {article?.read_minutes ?? 5} min read
        </p>
        <h3 className={`mt-3 font-display font-normal leading-[1.1] tracking-tight text-teal transition-colors duration-300 group-hover:text-moss ${featured ? "text-3xl sm:text-5xl" : "text-2xl"}`}>
          {article?.title}
        </h3>
        <p className="mt-4 text-[15px] leading-relaxed text-teal-ink/80">{article?.excerpt}</p>
      </div>
    </Link>
  </motion.article>
);
